import { Link } from "react-router-dom";
import { Logo } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

export default function PublicLayout({ children }) {
  const { user } = useAuth();
  return (
    <div className="flex min-h-screen flex-col bg-[#FAFAFA]">
      <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link to="/" data-testid="public-home-link"><Logo /></Link>
          <nav className="flex items-center gap-1 sm:gap-3">
            <Link to="/pricing" className="hidden rounded-full px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-100 sm:block" data-testid="public-pricing-link">Pricing</Link>
            <Link to="/help" className="hidden rounded-full px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-100 sm:block" data-testid="public-help-link">Help</Link>
            {user ? (
              <Link to="/dashboard" className="rounded-full bg-orange-500 px-4 py-2 text-sm font-semibold text-white hover:bg-orange-600" data-testid="public-dashboard-link">My trips</Link>
            ) : (
              <>
                <Link to="/login" className="rounded-full px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100" data-testid="public-login-link">Log in</Link>
                <Link to="/register" className="rounded-full bg-orange-500 px-4 py-2 text-sm font-semibold text-white hover:bg-orange-600" data-testid="public-signup-link">Start free</Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <div className="flex-1">{children}</div>
      <footer className="mt-24 bg-slate-900 text-slate-300">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:grid-cols-3 sm:px-6 lg:px-8">
          <div><Logo light /><p className="mt-3 text-sm text-slate-400">Group trips without the group-chat chaos.</p></div>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/pricing" className="hover:text-white" data-testid="footer-pricing">Pricing</Link>
            <Link to="/help" className="hover:text-white" data-testid="footer-help">Help & support</Link>
          </div>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy policy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of service</Link>
          </div>
        </div>
        <p className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">© 2026 Triply (working name). All rights reserved.</p>
      </footer>
    </div>
  );
}
